<template>
    <div>
        <div style="display: flex; margin-top: 1rem; padding-bottom: 2rem; border-bottom: 2px solid rgb(240, 240, 240);">
            <div style="width: 50%;">
                <div style="position: relative;">
                    <defect-group-bodywork-v1-input
                        v-if="isBodyworkInput"
                        :group-id="this.answer.additional_data ? this.answer.additional_data.group_id : null"
                        :value="internalValue.additional_data.defects"
                        @new="newDefect"
                        @existing="openDefectEditor"
                    ></defect-group-bodywork-v1-input>
                    <defect-group-interior-v1-input
                         v-if="isInteriorInput"
                        :group-id="this.answer.additional_data ? this.answer.additional_data.group_id : null"
                        :value="internalValue.additional_data.defects"
                        @new="newDefect"
                        @existing="openDefectEditor"
                    ></defect-group-interior-v1-input>
                </div>
            </div>
            <div style="padding-left: 3rem; width: 50%; margin-top: 1rem;">
                <div style="box-shadow: 1px 3px 5px 2px rgba(0,0,0,0.2); padding: 0rem; margin-bottom: 4rem;">
                    <div style="width: 100%; padding: 1rem; background:#f0f0f0;">
                        <h3 style="font-size: 1.25rem; margin: 0;">Defect List</h3>
                    </div>
                    <div style="padding: 0 .75rem 1rem;">
                        <table class="table" style="margin: 0;">
                    <thead>
                        <tr>
<!--                            <th style="width: 70px;">Item</th>-->
                            <th style="width: 39%; border-top: none;">Description</th>
                            <th style="width: 39%; border-top: none;">Job Card</th>
                            <th style="width: 75px; border-top: none;">Estimate</th>
                            <th style="border-top: none;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(defect, k) in internalValue.additional_data.defects">
                            <tr :class="[{hasNote: hasComment(defect)}]" @click="openDefectEditor(defect)" style="cursor: pointer;">
                                <td>
                                    <span style="vertical-align: middle; margin-right: 3px;">{{ defect.type | defectTypeLabel }}</span>
                                    <span class="marker marker-small">{{ k | letter }}</span>
                                    <div class="subtle">{{ defect.panel }}</div>
                                    <div v-if="defect.images && defect.images.length > 0">
                                        <img v-for="image in defect.images" :src="getImageUrl(image)" :alt="'Defect Image '"
                                            style="max-width: 32px; max-height: 32px; border-radius: 3px; margin-right: 5px; cursor: pointer;"
                                            @click.stop="showImage(image)">
                                    </div>
                                </td>
                                <td>
                                    <div v-if="defect.task">
                                        <div v-if="defect.task.template.template">
                                            {{ defect.task.template.template.title }}
                                            <div class="subtle">{{ defect.task.template.title }}</div>
                                        </div>
                                        <div v-else>
                                            {{ defect.task.template.title }}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <span v-if="defect.repair_estimate && defect.repair_estimate > 0">{{ defect.repair_estimate | currency(2) }}</span>
                                    <span v-else>-</span>
                                </td>
                                <td>
                                    <ui-icon-button
                                        type="secondary"
                                        size="small"
                                        icon="delete"
                                        @click.stop="removeDefect(defect)"
                                    ></ui-icon-button>
                                </td>
                            </tr>
                            <tr v-if="hasComment(defect)" class="is-note">
                                <td colspan="4">
                                    <div class="comments" style="display: flex;">
                                        <div style="min-width: 55px;"><span class="material-icons">notes</span></div>
                                        <div>{{ defect.comments }}</div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="noDefectsListed">
                            <td colspan="4">
                                <div class="text-center">
                                    No defects listed
                                    <div style="font-size: .9rem; color: #ccc;">Add one by clicking on the defective area on the vehicle.</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-if="!noDefectsListed">
                        <tr>
                            <td colspan="2"></td>
                            <td colspan="2">{{ estimateTotal | currency(2) }}</td>
                        </tr>
                    </tfoot>
                </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Defect Type Modal !-->
        <defect-type-modal
            ref="defectTypeModal"
            @save="saveCurrentDefect"
            @edit="openDefectEditor"
        ></defect-type-modal>

        <!-- Defect Modal !-->
        <defect-modal
            ref="defectModal"
            @save="saveCurrentDefect"
        ></defect-modal>

        <!-- Image Modal !-->
        <lightbox ref="imageModal"></lightbox>
    </div>
</template>

<script>
import {
    AnswerOutcomes,
    AnswerSchema,
    DefectGroupSchema,
    DefectTypeList
} from "../../classes/Api/Inspection";
import Filters from '../../filters';
import DefectGroupBodyworkV1Input from "./DefectGroupBodyworkV1Input";
import DefectModal from "./DefectModal";
import keyToLetter from "./KeyToLetter";
import "./DefectGroupStyles.scss";
import DefectTypeModal from "./DefectTypeModal.vue";
import Lightbox from "../elements/Lightbox.vue";
import DefectGroupInteriorV1Input from "./DefectGroupInteriorV1Input.vue";

export default {
    components: {
        DefectGroupInteriorV1Input,
        Lightbox,
        DefectTypeModal,
        DefectModal,
        DefectGroupBodyworkV1Input,
    },
    filters: {
        ...Filters,
        defectTypeLabel(v) {
            let type = DefectTypeList.find(i => i.value === v)

            if (type) {
                return type.label
            }
        },
        letter: keyToLetter
    },
    props: {
        question: {
            type: Object,
            required: true
        },
        answer: {
            type: Object
        }
    },
    data() {
        return {
            internalValue: null,
            openDefectIndex: -1,
            DefectTypeList,
        }
    },
    created() {
        this.setDefault()

        this.syncAnswersWithOriginal()

        this.setQuestionOutcome();
    },
    watch: {
        answer: {
            handler(n) {
                this.setAnswer(n)
            },
            deep: true
        }
    },
    computed: {
        isBodyworkInput() {
            return this.question.type === 'bodywork.defect.group'
        },
        isInteriorInput() {
            return this.question.type === 'interior.defect.group'
        },
        noDefectsListed() {
            return this.internalValue.additional_data.defects.length === 0
        },
        estimateTotal() {
            let total = 0

            this.internalValue.additional_data.defects.forEach(i => {
                if (i.repair_estimate) {
                    total += parseFloat(i.repair_estimate)
                }
            })

            return total
        },
    },
    methods: {
        getImageUrl(image) {
            return image.preview_url ? image.preview_url : image.url
        },
        showImage(image) {
            this.$refs.imageModal.open(
                this.getImageUrl(image)
            )
        },
        openDefectEditor(defect) {
            this.openDefectIndex = this.internalValue.additional_data.defects.findIndex(i => i === defect)

            this.$refs.defectModal.open(defect)
        },
        newDefect(defect) {
            this.openDefectIndex = this.internalValue.additional_data.defects.findIndex(i => i === defect)

            this.$refs.defectTypeModal.open(defect)
        },
        saveCurrentDefect(defect) {
            if (this.openDefectIndex === -1) {
                this.internalValue.additional_data.defects.push(defect)
            } else {
                this.$set(this.internalValue.additional_data.defects, this.openDefectIndex, defect)
            }
            
            this.$refs.defectModal.close()
            
            this.setQuestionOutcome()
            
            this.$emit('updated')
        },
        removeDefect(defect) {
            this.internalValue.additional_data.defects = this.internalValue.additional_data.defects.filter(i => i !== defect)

            this.setQuestionOutcome()

            this.$emit('updated')
        },
        hasComment(defect) {
            return defect.comments
        },
        setQuestionOutcome() {
            if (this.noDefectsListed) {
                this.internalValue.outcome =
                    this.internalValue.additional_data.outcome = AnswerOutcomes.OUTCOME_PASSED
                return
            }

            this.internalValue.outcome =
                this.internalValue.additional_data.outcome = AnswerOutcomes.OUTCOME_FAILED

            this.updated()
        },
        syncAnswersWithOriginal() {
            if (this.answer.additional_data !== null) {
                this.setAnswer(this.answer)
            }
        },
        setDefault() {
            this.internalValue = AnswerSchema({
                question_id: this.question.id,
                additional_data: DefectGroupSchema({
                    type: this.isBodyworkInput ? 'bodywork-v1' : 'interior-v1',
                    outcome: AnswerOutcomes.OUTCOME_SKIPPED
                })
            })

            this.updated()
        },
        setAnswer(answer = {}) {
            if (answer && answer.additional_data === null) {
                answer = Object.assign({}, answer, {
                    additional_data: DefectGroupSchema({
                        type: this.isBodyworkInput ? 'bodywork-v1' : 'interior-v1',
                        outcome: AnswerOutcomes.OUTCOME_SKIPPED
                    })
                })
            }

            this.$set(this, 'internalValue', answer)

            this.updated()
        },
        updated() {
            this.$emit('input', this.internalValue)
        }
    }
}
</script>

<style lang="scss" scoped>
    .comments {
        background: lightgoldenrodyellow;
        border-radius: 3px;
        padding: 1rem;
    }

    .diagram {
        cursor: pointer;
        width: 100%;
    }

    .has-note td {
        border-bottom: none;
        padding-bottom: 0;
    }

    .is-note td {
        border-top: none;
    }
</style>